import COLORS from "../../../assets/Colors";

export const statusColor = (status) => {
  const map = {
    active: {
      bg: COLORS.NOTIFICATION_BLUE,
      text: "#1f4e94",
      bd: "#b8cee8",
      label: "Active",
    },
    completed: {
      bg: COLORS.NOTIFICATION_GREEN,
      text: COLORS.BTN_GREEN,
      bd: "#b8d8c4",
      label: "Completed",
    },
    cancelled: {
      bg: COLORS.NOTIFICATION_RED,
      text: COLORS.NOTIFICATION_RED,
      bd: "#eababa",
      label: "Cancelled",
    },
    paid: {
      bg: COLORS.NOTIFICATION_GREEN,
      text: COLORS.BTN_GREEN,
      bd: "#b8d8c4",
      label: "Paid",
    },
    pending: {
      bg: COLORS.WARNING,
      text: COLORS.PRIMARY_WHITE,
      bd: "#f0deb8",
      label: "Pending",
    },
    refunded: {
      bg: "#f0f4fa",
      text: "#4a5770",
      bd: "#d0dcef",
      label: "Refunded",
    },
  };
  return (
    map[status] || {
      bg: "#f0f4f8",
      text: "#5c6b7f",
      bd: COLORS.BORDER_GREY,
      label: status,
    }
  );
};
